export default __webpack_public_path__ + "static/media/new_warranty_banner.dd690ed9.png";